export const PRESETS = [
  { value: 'day', label: '낮' }, { value: 'dawn', label: '새벽' },
  { value: 'dusk', label: '해질녘' }, { value: 'night', label: '밤' },
];

export const modelKey = model => `${model.id}/${model.version}`;
export const isIncluded = (catalog, model) => !!model && catalog.bundleSelection.some(ref => modelKey(ref) === modelKey(model));
export const assetSize = model => model.body.bytes + (model.lights?.bytes || 0);
export const formatBytes = bytes => bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(2)} MB` : `${Math.ceil(bytes / 1024)} KB`;

const groups = [
  ['modelId', '모델'], ['modelVersion', '버전'], ['name', '이름'], ['coordinate', '위치'], ['scale', '크기'], ['rotation', '회전'],
  ['altitude', '고도'], ['minZoom', '등장 줌'], ['fadeZoomRange', '페이드'], ['lighting', '조명'],
];

export function catalogChanges(catalog, saved) {
  if (!catalog || !saved) return [];
  const changes = [];
  catalog.placements.forEach(placement => {
    const before = saved.placements.find(p => p.id === placement.id);
    if (!before) {
      changes.push({ id: placement.id, label: placement.name, detail: `새 지도 배치 · ${placement.active ? '게시 준비' : '중단 상태로 준비'}` });
      return;
    }
    if (before.active !== placement.active) changes.push({ id: placement.id, label: `${placement.name} · 앱 지도 표시`, detail: `${before.active ? '활성' : '비활성'} → ${placement.active ? '활성' : '비활성'}` });
    const changed = groups.filter(([key]) => JSON.stringify(before[key]) !== JSON.stringify(placement[key])).map(([key, label]) => `${label}: ${JSON.stringify(before[key])} → ${JSON.stringify(placement[key])}`);
    if (changed.length) changes.push({ id: placement.id, label: placement.name, detail: changed.join(' · ') });
  });
  saved.placements.filter(p => !catalog.placements.some(next => next.id === p.id)).forEach(p => changes.push({ id: p.id, label: p.name, detail: '지도 배치 삭제 · 모델 파일은 유지' }));
  catalog.placements.forEach(p => {
    const before = saved.archivedPlacements?.includes(p.id) || false;
    const after = catalog.archivedPlacements?.includes(p.id) || false;
    if (before !== after) changes.push({ id: p.id, label: p.name, detail: after ? '보관 · 게시 중단 준비' : '보관함에서 복원 · 중단 상태로 복원' });
  });
  catalog.models.forEach(model => {
    const wasArchived = saved.archivedModels?.some(ref => modelKey(ref) === modelKey(model)) || false;
    const archived = catalog.archivedModels?.some(ref => modelKey(ref) === modelKey(model)) || false;
    if (wasArchived !== archived) changes.push({ id: modelKey(model), label: modelKey(model), detail: archived ? '모델 보관' : '모델 보관 해제' });
    const before = isIncluded(saved, model), after = isIncluded(catalog, model);
    if (before !== after) changes.push({ id: modelKey(model), label: `${model.id} / ${model.version} · 다음 빌드`, detail: `${before ? '포함' : '제외'} → ${after ? '포함' : '제외'}` });
  });
  return changes;
}

const inRange = (value, min, max) => typeof value === 'number' && Number.isFinite(value) && value >= min && value <= max;
export function placementErrors(placement) {
  if (!placement) return {};
  const errors = {};
  if (!placement.name.trim()) errors.name = '이름을 입력해 주세요.';
  [['longitude', placement.coordinate[0], -180, 180], ['latitude', placement.coordinate[1], -85, 85],
    ...placement.scale.map((value, index) => [`scale${index}`, value, 0.01, 100]),
    ['rotation', placement.rotation, 0, 360], ['altitude', placement.altitude, -500, 10000],
    ['minZoom', placement.minZoom, 0, 22], ['fadeZoomRange', placement.fadeZoomRange, 0.1, 3],
    ...PRESETS.map(({ value }) => [`lighting-${value}`, placement.lighting[value], 0, 1]),
  ].forEach(([key, value, min, max]) => { if (!inRange(value, min, max)) errors[key] = `${min}~${max} 범위의 숫자를 입력해 주세요.`; });
  return errors;
}

export const catalogHasErrors = catalog => catalog?.placements.some(placement => Object.keys(placementErrors(placement)).length > 0);
